export default __webpack_public_path__ + "static/media/cli-alph-resi_penisula.16b105ab.jpg";